import blockBgColorField from '../fields/blockBgColorField';

export default {
  value: 'newsletter',
  label: 'Newsletter',
  fields: [blockBgColorField]
};
